module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-garden"
  }, [_c('div', {
    staticClass: "clearfix index-title-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right index-title-more"
  }, [_c('span', {
    staticClass: "nb-a",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/' + _vm.topic.location + '/class/informationdesign')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t更多\n\t\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-caret-square-o-right color-main"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "index-content-block"
  }, [_c('div', {
    staticClass: "img-block",
    style: ('background-image:url(' + _vm.article.poster.url + ')')
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.article.content)
    }
  })]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left index-title"
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v("\n        虚拟课堂\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gif-content-block"
  }, [_c('a', {
    staticClass: "gif-a",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('img', {
    staticClass: "gif-item",
    attrs: {
      "alt": "1",
      "src": require("../../../../../common/assets/img/gif/1.gif")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "gif-a",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('img', {
    staticClass: "gif-item",
    attrs: {
      "alt": "1",
      "src": require("../../../../../common/assets/img/gif/2.gif")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "gif-a",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('img', {
    staticClass: "gif-item",
    attrs: {
      "alt": "1",
      "src": require("../../../../../common/assets/img/gif/3.gif")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-23b509fa"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/scenery/index/widget/IndexGarden.vue
// module id = 961
// module chunks = 1